"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Error = void 0;
var _layoutKit = require("@arvinxu/layout-kit");
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var _error = _interopRequireDefault(require("../components/alert/error"));
var _badge = _interopRequireDefault(require("../components/badge/badge"));
var _dangerButton = _interopRequireDefault(require("../components/button/dangerButton"));
var _dropdownError = _interopRequireDefault(require("../components/dropdown/dropdownError"));
var _menuDanger = _interopRequireDefault(require("../components/menu/menuDanger"));
var _error2 = _interopRequireDefault(require("../components/message/error"));
var _error3 = _interopRequireDefault(require("../components/notification/error"));
var _danger = _interopRequireDefault(require("../components/progress/danger"));
var _error4 = _interopRequireDefault(require("../components/tag/error"));
var _danger2 = _interopRequireDefault(require("../components/timeline/danger"));
var _danger3 = _interopRequireDefault(require("../components/upload/danger"));
var Error = exports.Error = function Error(_ref) {
  var id = _ref.id;
  return /*#__PURE__*/_react.default.createElement(_antd.Card, {
    size: 'small',
    id: id
  }, /*#__PURE__*/_react.default.createElement(_layoutKit.Flexbox, {
    horizontal: true,
    align: 'start',
    gap: 24
  }, /*#__PURE__*/_react.default.createElement(_layoutKit.Flexbox, {
    gap: 24
  }, /*#__PURE__*/_react.default.createElement(_layoutKit.Flexbox, {
    horizontal: true,
    align: 'center',
    gap: 12,
    style: {
      marginTop: 8
    }
  }, _dangerButton.default.demo, /*#__PURE__*/_react.default.createElement("div", null, _error4.default.demo), _badge.default.demo), _error.default.demo), /*#__PURE__*/_react.default.createElement(_layoutKit.Flexbox, {
    align: 'center',
    gap: 28
  }, _error2.default.demo, _danger.default.demo)), /*#__PURE__*/_react.default.createElement(_layoutKit.Flexbox, {
    horizontal: true,
    gap: 40,
    style: {
      marginTop: 32
    }
  }, /*#__PURE__*/_react.default.createElement("div", null, _error3.default.demo), /*#__PURE__*/_react.default.createElement("div", null, _danger2.default.demo)), /*#__PURE__*/_react.default.createElement(_layoutKit.Flexbox, {
    horizontal: true,
    gap: 40
  }, _menuDanger.default.demo, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: 300
    }
  }, _danger3.default.demo), _dropdownError.default.demo));
};